import type { ButtonHTMLAttributes } from 'react';
import type { Bilingual } from '../i18n/types';
import { BilingualText } from './BilingualText';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: Bilingual;
  variant?: 'primary' | 'success' | 'danger' | 'secondary' | 'ghost';
  size?: 'lg' | 'md';
  icon?: string;
}

export function BilingualButton({
  label,
  variant = 'primary',
  size = 'md',
  icon,
  className,
  ...rest
}: Props) {
  const classes = ['btn', `btn-${variant}`, `btn-${size}`, className]
    .filter(Boolean)
    .join(' ');
  return (
    <button {...rest} className={classes}>
      {icon && <span className="btn-icon">{icon}</span>}
      <BilingualText value={label} />
    </button>
  );
}
